import { withAuthenticationRequired } from '@auth0/auth0-react';
import { Card } from 'primereact/card';
import { useTranslation } from 'react-i18next';
import ResponsiveCustomerGroupDemandList
  from '@components/obsolete/multi-demand/ListCustomerGroupDemand/ResponsiveCustomerGroupDemandList.tsx';
import ResponsiveLayout from '@app/layout/ResponsiveLayout.tsx';

const ListCustomerGroupDemandPage = () => {
  const { t } = useTranslation('common');
  return (
    <ResponsiveLayout title={t(`ListCustomerGroupDemand.title`, `All group demands`)}>
      {/*
        // @ts-ignore*/}
      <Card>
        <ResponsiveCustomerGroupDemandList />
      </Card>
    </ResponsiveLayout>
  );
};

export default withAuthenticationRequired(ListCustomerGroupDemandPage);
